<template>
    
<div  v-if="this.$store.getters.Loaded && this.$store.getters.GetBlock.login" class="uk-section uk-flex ">   
    <div class="uk-margin-center uk-container uk-position-cente  uk-margin-xlarge-top">    
        <div class="uk-margin ">
            <div class="uk-inline uk-width-1-1 ">
                <span class="uk-form-icon " uk-icon="icon: user"></span>
                <input v-model="email" class="uk-input " type="email" aria-label="Not clickable icon" placeholder="Login" autocomplete="email">
            </div>
        </div>
    
        <div class="uk-margin ">
            <div class="uk-inline uk-width-1-1 ">
                <span class="uk-form-icon  " uk-icon="icon: lock"></span>
                <input v-model="pass" class="uk-input " type="password" aria-label="Not clickable icon" placeholder="Password"  autocomplete="current-password">
            </div>
        </div>
        
        <!-- Notification -->
    
        <div id="error" v-if="error.status" class="uk-alert-danger" uk-alert>
            <a class="uk-alert-close" uk-close v-on:click.stop.prevent="error.status=false"></a>
            <p>{{error[this.$store.getters.Lang]}}</p>
        </div>
        <div v-if="fill.status" id="fill"  class="uk-alert-danger" uk-alert>
            <a class="uk-alert-close" uk-close v-on:click.stop.prevent="fill.status=false"></a>
            <p>{{fill[this.$store.getters.Lang]}}</p>
        </div>

        <button class="uk-button uk-button-primary  uk-width-1-1" v-on:click="login">{{this.$store.getters.GetText.navbar.login[this.$store.getters.Lang]}}</button><br>
        <!--button class="uk-button uk-button-danger uk-margin uk-width-1-1">{{this.$store.getters.GetText.registration.cancel[this.$store.getters.Lang]}}</button-->
    </div>
    
    
</div>
</template>
<script>
import axios from 'axios'
export default {
    name: "LoginForm",
    data(){
        return{
            email:null,
            pass:null,
            error:{
                status: false,
                Ru:'Wrong login password pair!',
                En:'Неверная пара логин пароль!'
            },
            fill:{
                status:false,
                Ru:'Fields must be filled!',
                En:'Поля должны быть заполнены!'
            }
        }
    },
    methods:{
        login(){
            this.fill.status=false
            if (!!this.email && !!this.pass){
                this.error.status=false
                this.$store.commit('SET_Loaded',false)
                var $this= this
                axios.post('/api/auth/login',
            {
                email: this.email,
                password:this.pass
            }).then(
                result=>{
                    $this.$store.commit('SET_Loaded',true)                    
                    localStorage.access_token=result.data.access_token
                    $this.$router.push({name:'personal'})
                }
            ).catch(function(error) {
                    if (error.response) {
                        $this.$store.commit('SET_Loaded',true)
                        // The request was made and the server responded with a status code
                        // that falls out of the range of 2xx
                        $this.$store.commit('SET_Errors', [error.response.status, true])
                        $this.$store.commit('SET_ACCESS_DIR',true)
                        if (error.response.status==401){
                            $this.error.status=true
                        }

                    } else if (error.request) {
                        // The request was made but no response was received
                        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                        // http.ClientRequest in node.js
                        //context.commit('SET_Errors', [error.response.status, true])
                    } else {
                        // Something happened in setting up the request that triggered an Error
                        //context.commit('SET_Errors', [error.response.status, true])
                    }

                })
            } else {
                this.fill.status=true
            }
            
        }
    }
}
</script>